<!--
 * @Author: your name
 * @Date: 2025-09-19 09:37:33
 * @LastEditTime: 2025-10-15 16:27:16
 * @LastEditors: MincdeMac-mini.local
 * @Description: In User Settings Edit
 * @FilePath: /fe-app/src/views/insurance/team/Finished.vue
-->
<template>
  <div class="box">
    <van-icon class="icon" size="100" color="#E99D42" name="checked" />
    <div class="tips">提交成功</div>
    <div class="confirm">
      <van-button class="confirm-btn" color="#E99D42" @click="handleGoBack">返回首页</van-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      idcard: ''
    }
  },
  methods: {
    handleGoBack() {
      sessionStorage.removeItem('X-Authorization')
      sessionStorage.removeItem('Authorization')
      sessionStorage.removeItem('idcard')
      sessionStorage.removeItem('form')
      sessionStorage.removeItem('info')
      sessionStorage.removeItem('tracert-session-key')
      this.refreshPage()
      setTimeout(() => {
        this.$router.replace('/team/team-login')
      }, 1000)
    },
    // 强制刷新页面
    refreshPage() {
      window.location.reload()
    }
  }
}
</script>

<style lang="stylus" scoped>
body{
  width: 100%
  .box{
    position relative
    height: 100vh
    overflow-y: scroll
    text-align: center
    .icon{
      margin: 240px 0 10px 0
    }
    .tips{
      font-size: 32px
      font-weight: bold
    }
    .confirm{
        position: fixed
        bottom: 20px
        margin: 30px 85px
        text-align: center
        .confirm-btn{
          border-radius: 20px
          width: 580px
        }
      }
  }
}
</style>
